module.exports = __webpack_public_path__ + "img/w79.afecf10c.svg";